import GlobalConstants from "../config/GlobalConstants";

const CALLBACK_NAME = "tigerGoogleMapsLoaded";

let placesLibrary = null;

/**
 * Loads the places library of the Google Maps JavaScript API once per page.
 * Resolves to null if no api key is configured or the api can't be loaded, so callers simply work without it.
 */
export function loadPlacesLibrary() {
    if (!placesLibrary) {
        placesLibrary = loadMapsApi()
            .then(maps => maps != null ? maps.importLibrary("places") : null)
            .catch(error => {
                console.warn("Address suggestions not available:", error);
                return null;
            });
    }
    return placesLibrary;
}

function loadMapsApi() {
    //already loaded on this page, e.g. by another script
    if (window.google?.maps?.importLibrary) {
        return Promise.resolve(window.google.maps);
    }
    if (!GlobalConstants.GOOGLE_MAPS_API_KEY) {
        return Promise.resolve(null);
    }
    return new Promise((resolve, reject) => {
        window[CALLBACK_NAME] = () => resolve(window.google.maps);
        const script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GlobalConstants.GOOGLE_MAPS_API_KEY)
            + "&v=weekly&loading=async&language=de&callback=" + CALLBACK_NAME;
        script.async = true;
        script.onerror = () => reject(new Error("Google Maps JavaScript API could not be loaded"));
        document.head.appendChild(script);
    });
}
